<template>
  <v-content>
    <v-layout>
      <div class="file">
        <span v-if="!files">選擇圖片</span>
        <input v-if="!files"
               ref="files"
               type="file" multiple :name="uploadFieldName"
               @change="handleFilesUpload()"
               accept="image/*" class="input-file">
        <span v-else>已選擇圖片 ({{this.files.length}})</span>
      </div>
      <v-btn depressed dark :color="Theme.GREEN" :loading="saveLoading" style="margin-top: 5px" @click="upload">上傳</v-btn>
      <v-flex v-if="percentage !==''">
        <span style="text-align: center; margin: 5px;">{{percentage}}</span>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="500px">
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
        <v-card>
          <v-card-title>
            <span class="title">編輯</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap column>
                <v-flex xs12 sm6 md4
                        v-for="col in columnKeys
                                            .filter(item=>item.value !== 'action')"
                        :key="col.value">
                  <v-layout row wrap v-if="col.value === 'createDate'">
                                            <span>建立時間：
                                                {{format(editedItem[col.value])}}
                                            </span>
                  </v-layout>
                  <v-text-field v-else
                                v-model="editedItem[col.value]"
                                :label="col.text"
                                :rules="col.rules"
                                :disabled="col.disabled"
                                :required="col.required"></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat
                   @click="dialog = false">取消</v-btn>
            <v-btn color="blue darken-1" flat
                   @click="save"
                   :loading="loading"
                   :disabled="loading">儲存</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <table-view :items="list"
                :columnKeys="columnKeys"
                :pagination="pagination"
                :rows-per-page-items="[30,100,200,1000]"
                :loading="loading"
                @changePage="changePage"
                @cellEvent="cellEvent"/>

    <v-snackbar
        v-model="snackBar"
        :right="true"
        :timeout="3000"
        :top="true"
        :vertical="false">
      {{ snackText }}
    </v-snackbar>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {formatDateTime} from "@/utils/tools";
import common from "@/mixins/common";
import TableView from "@/components/TableView";
import Notification from "@/utils/notice_manager";

export default {
  name: "productImages",
  components: {
    TableView
  },
  mixins:[common],
  data() {
    return {
      list:[],
      snackBar: false,
      snackText: '',
      files: '',
      uploadedFiles: [],
      uploadFieldName: 'files',
      pagination: {
        page: 1,
        itemsPerPage: 30,
        totalItems: 0,
      },
      saveLoading: false,
      percentage: '',
      loading: false,
      valid: true,
      dialog: false,
      editedItem: {
      },

    };
  },
  created() {
    this.loadData();

    Notification.addObserver('fileProgress', (percentage)=>{
      this.percentage = `${percentage}%`;
    });
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    columnKeys() {
      return [
        {
          value: 'url',
          text: '縮圖',
          sortable: false,
          required: true,
          disabled: true,
          isImage: true,
        },
        {
          value: 'name',
          text: '檔案名稱',
          sortable: false,
          required: true,
          disabled: true,
        },
        {
          value: 'url',
          text: '網址',
          sortable: false,
          required: true,
          disabled: true,
        },
        {
          value: 'copy', text: '複製網址', color: this.Theme.GREEN, sortable: false, disabled: true, width: 170, isEvent:true,
        },
        {
          value: 'delete', text: '刪除', sortable: false, disabled: true, width: 170, isEvent:true,
        },
      ];
    },
  },
  methods: {
    ...mapActions(['getProductImageList', 'removeProductImage',
      'uploadFile']),
    async loadData(){
      this.loading = true;
      const res = await this.getProductImageList({
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
        searchValue:this.searchValue,
      });

      const result = res.data;
      if (result && result.statusCode === 0){
        this.list = result.data.list;
        this.pagination.totalItems = result.data.header.totalCount;

        console.log(`getProductImageList ${JSON.stringify(result.data.list)}`);
      }
      this.loading = false;
    },
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'copy'){
        this.copyURL(cell.item.url);
      } else if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此資料？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteFile(cell.item);
          }
        });
      }
    },
    handleFilesUpload() {
      this.files = this.$refs.files.files;
      console.log('handleFilesUpload');
    },
    upload() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i += 1) {
        const file = this.files[i];
        formData.append(`file[${i}]`, file);
      }

      try {
        this.saveLoading = true;
        this.uploadFile({ fileList: formData
          , token: this.getUserInfo.token }).then((response) => {
          console.log(`upload ... ${JSON.stringify(response)}`);
          if (response.status === 200) {
            console.log('上傳成功');
            this.snackText = '檔案上傳成功！';
            this.snackBar = true;
            this.loadData();
            this.files = '';
            this.saveLoading = false;
            this.percentage = '';
          }
        }).catch((e) => {
          console.log(`upload error `, e);
          this.saveLoading = false;
          this.percentage = '';
          this.files = '';
          this.showAlert({
            title: '上傳錯誤',
            content: `錯誤 ${e.message}`,
            showCancel: false,
            confirmEvent: async () => {
              this.hideAlert();
            }
          });
        });
      } catch (e) {
        console.log(`upload error `, e);
        this.saveLoading = false;
        this.percentage = '';
        this.showAlert({
          title: '上傳錯誤',
          content: `錯誤 ${e.message}`,
          showCancel: false,
          confirmEvent: async () => {
            this.hideAlert();
          }
        });
      }
    },
    format(time) {
      return formatDateTime(time);
    },
    formatCategory(category) {
      if (category === 'normal') {
        return '無分類';
      }
      return category;
    },
    copyURL(url) {
      console.log(`copyURL = ${url}`);
      const input = document.createElement('input');
      input.setAttribute('value', url);
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.snackText = '已複製網址！';
      this.snackBar = true;
    },
    showEditView(props) {
      this.editedItem = props.item;
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        // const params = {
        //   fileId: this.editedItem.fileId,
        //   category: this.editedItem.category,
        //   isDelete: this.editedItem.isDelete,
        // };
        // this.saveFileInfo(params).then((response) => {
        //   this.loading = false;
        //   this.snackText = '儲存成功！';
        //   this.snackBar = true;
        //   if (this.editedItem.isDelete === 1) {
        //     this.fetchFileList();
        //   }
        // }, (error) => {
        //   this.snackText = `發生錯誤 ${JSON.stringify(error)}`;
        //   this.snackBar = true;
        //   this.loading = false;
        // });
      }
    },
    async deleteFile(item) {
      const res = await this.removeProductImage({
        imageId: item.imageId,
      });

      const result = res.data;
      if (result && result.statusCode === 0){
        this.snackText = '刪除成功！';
        this.snackBar = true;
        this.loadData();
      }
    },
  },
}
</script>

<style scoped>
.file {
  width: 150px;
  height: 36px;
  padding:5px 10px;
  background:#f29b87;
  border: 1px solid #f29b87;
  position:relative;
  color:#fff;
  border-radius: 5px;
  text-align:center;
  float:left;
  cursor:pointer;
  margin: 6px;
}
.input-file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
  border-radius: 5px;
}
</style>
